const { createSlice } = require('@reduxjs/toolkit');
const initialState = {
  AllPlans: {},
  SuppPlans: {},
  PlanDetailSuppPlans: {},
  suppPlansTabs: {},
  enableCallBar: {},
  releaseCallBar: {},
  enable: {},
  modifyInternet: {},
  queryBalanceInternet: {},
};
const CustomerBillRetrieve = createSlice({
  name: 'GetCustBillData',
  initialState,
  reducers: {
    getCustBillRetrieveResPlans: (state, action) => {
      state.AllPlans = action.payload;
    },
    getCustBillRetrieveByMsisdn: (state, action) => {
      state.SuppPlans = action.payload;
    },
    getCustBillRetrieveByMsisdnModify: (state, action) => {
      state.modifyInternet = action.payload;
    },
    getQueryMultipleResponseInternet: (state, action) => {
      state.queryBalanceInternet = action.payload;
    },
    getCustBillRetrieveByMsisdnSupp: (state, action) => {
      state.PlanDetailSuppPlans = action.payload;
    },
    setSuppPlanDetails: (state, action) => {
      state.suppPlansTabs = action.payload;
    },
     setEnableBulkCallBar: (state, action) => {
      state.enableCallBar = action.payload;
    },
     setReleaseBulkCallBar: (state, action) => {
      state.releaseCallBar = action.payload;
    },
     SetEnable: (state, action) => {
      state.enable = action.payload;
    },
    resetCustBillState: () => initialState,
  },
});
export const {
  getCustBillRetrieveResPlans,
  getCustBillRetrieveByMsisdn,
  getCustBillRetrieveByMsisdnModify,
  getQueryMultipleResponseInternet,
  getCustBillRetrieveByMsisdnSupp,
  setSuppPlanDetails,
  setEnableBulkCallBar,
  setReleaseBulkCallBar,
  SetEnable,
  resetCustBillState,
} = CustomerBillRetrieve.actions;
export default CustomerBillRetrieve.reducer;
